export enum FirstStartWizardStep {
    Profile = 'Profile',
    AcceptInvitations = 'AcceptInvitations',
    AcceptPracticeInvitations = 'AcceptPracticeInvitations',
    MobileSuccessInfo = 'MobileSuccessInfo',
    PreAhaMoment = 'PreAhaMoment',
}

export interface SetupProfileWizardProps {
    onShowPreAhaMoment: () => void;
}
